import React, { CSSProperties, FC, useEffect, useState } from 'react';
import { EMPTY_VALUE } from './consts';
import { IFixableProps, TPosition } from './models';
import { usePosition } from '@src/hooks/usePosition';
import { classnames } from '@src/utils/classnames';
import { getClasses } from '@src/utils/getClass';
import styled from './Fixable.scss';

/** Компонент для фиксации контейнера  */
export const Fixable: FC<IFixableProps> = ({
  className,
  parentRef,
  children,
  isScroll,
  offset = 0,
  position: propsPosition = 'fixed',
  fixedPosition = 'top',
  style: propStyle,
  onFixed,
}) => {
  const position = usePosition(parentRef);
  const [fixed, setFixed] = useState<TPosition | typeof EMPTY_VALUE>(isScroll ? EMPTY_VALUE : fixedPosition);

  useEffect(() => {
    if (!isScroll) {
      setFixed(fixedPosition);
      return;
    }

    if (typeof position?.[fixedPosition] === 'number') {
      const isFixed = position[fixedPosition] < offset;
      setFixed(() => (isFixed ? fixedPosition : EMPTY_VALUE));
    }
  }, [fixedPosition, offset, position, isScroll]);

  useEffect(() => {
    if (onFixed) {
      onFixed(!!fixed);
    }
  }, [fixed, onFixed]);

  const stylePosition = isScroll ? (fixed ? propsPosition : EMPTY_VALUE) : propsPosition;
  const classes = classnames(className, ...getClasses(styled, { position: stylePosition }));
  const style: CSSProperties = {
    ...propStyle,
    [fixedPosition]: fixed ? offset : undefined,
  };

  return (
    <div className={classes} style={style}>
      {children}
    </div>
  );
};
